

export default class Sheet {
    /** @type {import("xlsx").WorkSheet} */
    constructor(sheet) {
        this.raw = sheet;
    }

    readRows(columns, { startRow, anchorColumn }) {
        const data = [];
        let row;

        for(row = startRow; ;row++) {
            const anchorColValue = this.getCell(anchorColumn, row);
            
            // Only end when anchor column cell is empty
            if(!anchorColValue) break;

            const rowData = {...columns};
            for(const key in rowData) {
                const col = rowData[key];
                const value = this.getCell(col, row)?.v;
                rowData[key] = value;
            }

            data.push(rowData);
        }
        
        

        return { data, startRow, endRow: row - 1 };
    }

    getCell(column, row) {
        return this.raw[column+row];
    }
}